import { render, staticRenderFns } from "./AppointmentPost.vue?vue&type=template&id=44ca57c6&scoped=true&lang=html"
import script from "./AppointmentPost.vue?vue&type=script&lang=js"
export * from "./AppointmentPost.vue?vue&type=script&lang=js"
import style0 from "./AppointmentPost.vue?vue&type=style&index=0&id=44ca57c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca57c6",
  null
  
)

export default component.exports